<script lang="ts">
	import { formatify } from "@core/utils/formatify.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";

	const { COOKIES } = getGlobalSettings();

	const descriptions: Record<string, string> = {
		"Nezbytně nutné soubory":
			"Nezbytně nutné soubory cookie umožňují základní funkce webových stránek, jako je přihlášení uživatele a správa účtu. Webové stránky nelze bez nezbytně nutných souborů cookie správně používat.",
		"Výkonové soubory":
			"Výkonové soubory cookie se používají ke sledování toho, jak návštěvníci webové stránky používají, jde např. o analytické soubory cookie. Tyto soubory cookie nelze použít k přímé identifikaci určitého návštěvníka.",
		"Soubory cílení":
			"Soubory cookie cílení se používají k identifikaci návštěvníků mezi různými webovými stránkami, např. obsahovými partnery a bannerovými sítěmi. Tyto soubory cookie mohou společnosti použít k vytvoření profilu zájmů návštěvníků nebo k zobrazování relevantních reklam na jiných webových stránkách.",
	};

	let div = $state<HTMLDivElement>();

	$effect(() => {
		if (div !== undefined) {
			for (const h4 of div.querySelectorAll("h4")) {
				const content = h4.innerText.trim().replace(/\s+/gu, " ");
				const key = Object.keys(descriptions).find((key) => key.toLowerCase() === content.toLowerCase());

				if (key !== undefined) {
					const paragraph = document.createElement("p");
					paragraph.append(formatify(descriptions[key]));
					paragraph.classList.add("mb-2");
					h4.after(paragraph);
				}
			}
		}
	});

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div bind:this={div}>
	{@html `<script type="text/javascript" charset="UTF-8" data-cookiescriptreport="report" src="//report.cookie-script.com/r/${COOKIES}.js"></script>`}
</div>

<style lang="postcss">
	div {
		@apply overflow-x-auto contain-inline-size;

		:global(._CookieScriptReportPageTable) {
			@apply block min-w-[47.375rem] max-w-[100cqw] overflow-auto font-sans;
		}

		:global(._CookieScriptReportPageSaveSettingButton) {
			@apply text-2xs/[1.2] bg-cmcprimary disabled:text-cmcmidgray disabled:bg-cmclightgray rounded-lg px-2.5 py-1 font-semibold uppercase tracking-[0.05em] text-white transition-all duration-300 hover:bg-[#008ABD] md:rounded-xl md:py-2 md:pl-4 md:pr-2 md:text-base/none;
		}

		:global(._CookieScriptReportPageCheckboxInput) {
			@apply accent-cmcprimary mr-1;
		}

		:global(._CookieScriptReportPageCheckboxText) {
			@apply my-1 font-sans text-base font-medium;
		}

		:global(h4) {
			@apply font-druk-cond text-cmcsecondary mb-1 mt-4 text-3xl font-semibold uppercase;
		}
	}
</style>
